var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors, opacities } from '../../../defaultTheme';
const SwitchInput = styled.input `
  appearance: none;
  z-index: -1;
  position: absolute;
  right: 6px;
  top: -8px;
  display: block;
  margin: 0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  outline: none;
  opacity: 0;
  transform: scale(1);
  background-color: transparent;
  pointer-events: none;
  transition: opacity 0.3s 0.1s, transform 0.2s 0.1s;
  &:checked {
    transform: translateX(16px);
  }

  &:focus:checked {
    background-color: ${({ theme }) => theme.switch.background};
    opacity: ${opacities.light24};
  }

  &:focus:not(:checked) {
    background-color: ${colors.heavyGrey};
    opacity: ${opacities.light38};
    z-index: 0;
  }
`;
const SwitchContainer = styled.label `
  position: relative;
  display: inline-block;
  font-size: 16px;
  line-height: 1.5;
  &:hover > ${SwitchInput}:checked:not(:disabled) {
    background-color: ${({ theme }) => theme.switch.background};
    opacity: ${opacities.light24};
  }

  &:hover > ${SwitchInput}:not(:checked):not(:disabled) {
    background-color: ${colors.heavyGrey};
    opacity: ${opacities.light38};
    z-index: 0;
  }

  ${SwitchInput}:active {
    transform: scale(0);
    transition: transform 0s, opacity 0s;
  }
`;
const Slider = styled.span `
  display: inline-block;
  width: 100%;
  cursor: pointer;

  &::before {
    content: '';
    display: inline-block;
    margin: 5px 0 5px 10px;
    border-radius: 7px;
    width: 36px;
    height: 14px;
    background-color: ${colors.lightestGrey};
    opacity: 1;
    vertical-align: top;
    transition: background-color 0.2s, opacity 0.2s;
  }

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    right: 16px;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background-color: ${({ disabled }) => disabled ? colors.lightGrey : colors.white};
    box-shadow: 0 3px 1px -2px ${opacities.rgbaLight20},
      0 2px 2px 0 ${opacities.rgbaLight14}, 0 1px 5px 0 ${opacities.rgbaLight12};
    transition: background-color 0.2s, opacity 0.2s, transform 0.2s;
  }

  ${SwitchInput}:checked + &::before {
    background-color: ${({ disabled, theme }) => disabled ? colors.lightGrey : theme.switch.background};
    opacity: ${opacities.light38};
  }

  ${SwitchInput}:checked + &::after {
    background-color: ${({ disabled, theme }) => disabled ? colors.lightGrey : theme.switch.background};
    opacity: 1;
    transform: translateX(16px);
  }
`;
const Switch = (_a) => {
    var { disabled = false, checked = false, name = 'switch', className, onChange = () => { } } = _a, props = __rest(_a, ["disabled", "checked", "name", "className", "onChange"]);
    return (_jsxs(SwitchContainer, Object.assign({ className: className }, { children: [_jsx(SwitchInput, Object.assign({}, props, { type: "checkbox", disabled: disabled, onChange: onChange, defaultChecked: checked, "aria-label": name, "aria-checked": checked })), _jsx(Slider, { disabled: disabled })] })));
};
export default Switch;
//# sourceMappingURL=Switch.js.map